module.exports = __webpack_public_path__ + "static/media/pagina1-boompje2_tijdslijn.d65ac4bc.svg";